import InputTextComponent from "presentation/components/Shared/InputTextComponent";

/**
 * Propriedades para o componente VacationBalance.
 */
interface VacationBalanceProps {
  /** O número de dias de férias disponíveis do ano anterior. */
  lastYearDays: number;
  /** O número de dias de férias disponíveis do ano corrente. */
  currentYearDays: number;
}

/**
 * `VacationBalance` é um componente de apresentação que exibe o saldo de dias de
 * férias do utilizador, separados por ano anterior e ano corrente.
 *
 * @param {VacationBalanceProps} props - As propriedades do componente.
 * @returns {React.FC} Um componente funcional React que renderiza os saldos de férias.
 */
const VacationBalance: React.FC<VacationBalanceProps> = ({
  lastYearDays,
  currentYearDays,
}) => {
  return (
    <>
      <div className="timesheet-1-col mt-5" style={{ position: "relative", display: "inline-block" }}>
        <InputTextComponent
          label="Dias disponíveis no ano anterior"
          fieldName="name"
          currentObject={lastYearDays}
          getValue={lastYearDays.toString()}
          isDisable={true}
          setValue={() => { }}
        />

        <i
          className="pi pi-info-circle cursor-pointer"
          style={{
            color: "#2196F3",
            position: "absolute",
            right: "5px", 
            top: "7%",
            transform: "translateY(-50%)",
          }}
          title="Os dias disponíveis do ano anterior apenas podem ser utilizados em férias com data limite até 30/04."
        />
      </div>

      <div className="timesheet-1-col mt-5">
        <div>
          {" "}
          <InputTextComponent
            label="Dias disponíveis no  ano atual"
            fieldName="name"
            currentObject={currentYearDays}
            getValue={currentYearDays.toString()}
            isDisable={true}
            setValue={() => { }} // Apenas para exibição
          />
        </div>
      </div>
    </>
  );
};

export default VacationBalance;
